/**
 * マニュアル目次構造定義
 *
 * マニュアルページで使用する目次のデータ構造
 */

export interface ManualItem {
  id: string;
  title: string;
  path: string;
  children?: ManualItem[];
}

/**
 * マニュアル目次構造
 * TODO: 実際にはサーバーからマニュアル一覧を取得する
 */
export const MANUAL_STRUCTURE: ManualItem[] = [
  {
    id: "00",
    title: "システム全体像",
    path: "00_システム全体像",
    children: [
      { id: "00-01", title: "システム概要", path: "00_システム全体像/システム概要.md" },
      { id: "00-02", title: "処理フロー全体図", path: "00_システム全体像/処理フロー全体図.md" },
      { id: "00-03", title: "データ構造", path: "00_システム全体像/データ構造.md" },
    ],
  },
  {
    id: "01",
    title: "処理パイプライン詳解",
    path: "01_処理パイプライン詳解",
    children: [
      { id: "01-01", title: "STEP1: 受信処理", path: "01_処理パイプライン詳解/STEP1_受信処理.md" },
      { id: "01-02", title: "STEP2: 取引先特定", path: "01_処理パイプライン詳解/STEP2_取引先特定.md" },
      { id: "01-03", title: "STEP3: OCR処理", path: "01_処理パイプライン詳解/STEP3_OCR処理.md" },
      { id: "01-04", title: "STEP4: CSV生成", path: "01_処理パイプライン詳解/STEP4_CSV生成.md" },
      { id: "01-05", title: "STEP5: メール送信", path: "01_処理パイプライン詳解/STEP5_メール送信.md" },
      { id: "01-06", title: "エラーと再処理", path: "01_処理パイプライン詳解/エラーと再処理.md" },
    ],
  },
  {
    id: "02",
    title: "シナリオガイド",
    path: "02_シナリオガイド",
    children: [
      {
        id: "02-01",
        title: "新規導入シナリオ",
        path: "02_シナリオガイド/新規導入シナリオ",
        children: [
          { id: "02-01-00", title: "導入前の準備", path: "02_シナリオガイド/新規導入シナリオ/00_導入前の準備.md" },
          { id: "02-01-01", title: "顧客の作成", path: "02_シナリオガイド/新規導入シナリオ/01_顧客の作成.md" },
          { id: "02-01-02", title: "FAX複合機への設定", path: "02_シナリオガイド/新規導入シナリオ/02_FAX複合機への設定.md" },
          { id: "02-01-03", title: "取引先の追加", path: "02_シナリオガイド/新規導入シナリオ/03_取引先の追加.md" },
          { id: "02-01-04", title: "CSV設定", path: "02_シナリオガイド/新規導入シナリオ/04_CSV設定.md" },
          { id: "02-01-05", title: "メール設定", path: "02_シナリオガイド/新規導入シナリオ/05_メール設定.md" },
          { id: "02-01-06", title: "テスト送信", path: "02_シナリオガイド/新規導入シナリオ/06_テスト送信.md" },
          { id: "02-01-07", title: "結果確認と調整", path: "02_シナリオガイド/新規導入シナリオ/07_結果確認と調整.md" },
          { id: "02-01-08", title: "本番稼働", path: "02_シナリオガイド/新規導入シナリオ/08_本番稼働.md" },
        ],
      },
      {
        id: "02-02",
        title: "トラブル対応シナリオ",
        path: "02_シナリオガイド/トラブル対応シナリオ",
        children: [
          { id: "02-02-01", title: "FAXが届かない", path: "02_シナリオガイド/トラブル対応シナリオ/FAXが届かない.md" },
          { id: "02-02-02", title: "取引先が特定されない", path: "02_シナリオガイド/トラブル対応シナリオ/取引先が特定されない.md" },
          { id: "02-02-03", title: "CSVの内容がおかしい", path: "02_シナリオガイド/トラブル対応シナリオ/CSVの内容がおかしい.md" },
          { id: "02-02-04", title: "メールが届かない", path: "02_シナリオガイド/トラブル対応シナリオ/メールが届かない.md" },
          { id: "02-02-05", title: "処理がエラーになる", path: "02_シナリオガイド/トラブル対応シナリオ/処理がエラーになる.md" },
        ],
      },
    ],
  },
  {
    id: "03",
    title: "設定ガイド",
    path: "03_設定ガイド",
    children: [
      {
        id: "03-01",
        title: "顧客設定",
        path: "03_設定ガイド/顧客設定",
        children: [
          { id: "03-01-01", title: "顧客とは", path: "03_設定ガイド/顧客設定/顧客とは.md" },
          { id: "03-01-02", title: "サブメールアドレスとは", path: "03_設定ガイド/顧客設定/サブメールアドレスとは.md" },
          { id: "03-01-03", title: "顧客の追加手順", path: "03_設定ガイド/顧客設定/顧客の追加手順.md" },
          { id: "03-01-04", title: "FAX複合機への設定", path: "03_設定ガイド/顧客設定/FAX複合機への設定.md" },
          { id: "03-01-05", title: "顧客設定がフローに与える影響", path: "03_設定ガイド/顧客設定/顧客設定がフローに与える影響.md" },
          { id: "03-01-06", title: "顧客の編集と削除", path: "03_設定ガイド/顧客設定/顧客の編集と削除.md" },
        ],
      },
      {
        id: "03-02",
        title: "取引先設定",
        path: "03_設定ガイド/取引先設定",
        children: [
          { id: "03-02-01", title: "取引先とは", path: "03_設定ガイド/取引先設定/取引先とは.md" },
          {
            id: "03-02-02",
            title: "名寄せ設定",
            path: "03_設定ガイド/取引先設定/名寄せ設定",
            children: [
              { id: "03-02-02-01", title: "名寄せとは何か", path: "03_設定ガイド/取引先設定/名寄せ設定/名寄せとは何か.md" },
              { id: "03-02-02-02", title: "名寄せ処理の詳細", path: "03_設定ガイド/取引先設定/名寄せ設定/名寄せ処理の詳細.md" },
              { id: "03-02-02-03", title: "パターン登録の手順", path: "03_設定ガイド/取引先設定/名寄せ設定/パターン登録の手順.md" },
              { id: "03-02-02-04", title: "自動学習の仕組み", path: "03_設定ガイド/取引先設定/名寄せ設定/自動学習の仕組み.md" },
            ],
          },
          {
            id: "03-02-03",
            title: "伝票種別設定",
            path: "03_設定ガイド/取引先設定/伝票種別設定",
            children: [
              { id: "03-02-03-01", title: "伝票種別とは", path: "03_設定ガイド/取引先設定/伝票種別設定/伝票種別とは.md" },
              { id: "03-02-03-02", title: "エイリアスの設定方法", path: "03_設定ガイド/取引先設定/伝票種別設定/エイリアスの設定方法.md" },
            ],
          },
        ],
      },
      {
        id: "03-03",
        title: "AI OCR設定",
        path: "03_設定ガイド/AI_OCR設定",
        children: [
          { id: "03-03-01", title: "AI OCR設定画面の使い方", path: "03_設定ガイド/AI_OCR設定/AI_OCR設定画面の使い方.md" },
          { id: "03-03-02", title: "プロンプトの編集方法", path: "03_設定ガイド/AI_OCR設定/プロンプトの編集方法.md" },
        ],
      },
    ],
  },
  {
    id: "04",
    title: "イベントログ",
    path: "04_イベントログ",
    children: [
      { id: "04-01", title: "イベントログの役割", path: "04_イベントログ/イベントログの役割.md" },
      { id: "04-02", title: "ログとパイプラインの対応", path: "04_イベントログ/ログとパイプラインの対応.md" },
      { id: "04-03", title: "詳細パネルの読み方", path: "04_イベントログ/詳細パネルの読み方.md" },
      { id: "04-04", title: "フィルター活用法", path: "04_イベントログ/フィルター活用法.md" },
      { id: "04-05", title: "再処理のタイミングと方法", path: "04_イベントログ/再処理のタイミングと方法.md" },
      { id: "04-06", title: "操作ログとイベントログの違い", path: "04_イベントログ/操作ログとイベントログの違い.md" },
    ],
  },
  {
    id: "05",
    title: "利用統計",
    path: "05_利用統計",
    children: [
      { id: "05-01", title: "利用統計の概要", path: "05_利用統計/利用統計の概要.md" },
      { id: "05-02", title: "月別データの見方", path: "05_利用統計/月別データの見方.md" },
      { id: "05-03", title: "CSVエクスポート", path: "05_利用統計/CSVエクスポート.md" },
    ],
  },
  {
    id: "06",
    title: "トラブルシューティング",
    path: "06_トラブルシューティング",
    children: [
      { id: "06-01", title: "よくある質問", path: "06_トラブルシューティング/よくある質問.md" },
      { id: "06-02", title: "エラーメッセージ一覧", path: "06_トラブルシューティング/エラーメッセージ一覧.md" },
    ],
  },
  {
    id: "07",
    title: "AIアシスタント",
    path: "07_AIアシスタント",
    children: [
      { id: "07-01", title: "AIアシスタントとは", path: "07_AIアシスタント/AIアシスタントとは.md" },
      { id: "07-02", title: "基本的な使い方", path: "07_AIアシスタント/基本的な使い方.md" },
      { id: "07-03", title: "効果的な質問の仕方", path: "07_AIアシスタント/効果的な質問の仕方.md" },
      { id: "07-04", title: "画像を使った質問", path: "07_AIアシスタント/画像を使った質問.md" },
      { id: "07-05", title: "AIが参照する情報", path: "07_AIアシスタント/AIが参照する情報.md" },
      { id: "07-06", title: "AIが答えられないこと", path: "07_AIアシスタント/AIが答えられないこと.md" },
      { id: "07-07", title: "セッション履歴の確認", path: "07_AIアシスタント/セッション履歴の確認.md" },
    ],
  },
  {
    id: "08",
    title: "ファイル配信クライアント",
    path: "08_ファイル配信クライアント",
    children: [
      { id: "08-01", title: "クライアントとは", path: "08_ファイル配信クライアント/クライアントとは.md" },
      { id: "08-02", title: "導入手順", path: "08_ファイル配信クライアント/導入手順.md" },
      { id: "08-03", title: "設定と運用", path: "08_ファイル配信クライアント/設定と運用.md" },
      { id: "08-04", title: "トラブルシューティング", path: "08_ファイル配信クライアント/トラブルシューティング.md" },
    ],
  },
];
